import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useFormik } from "formik";
import { createStoreOnPlan, getStorePlans } from "../services/store";
import { formatPrice } from "../helpers/format";
import { IconX } from "@tabler/icons-react";
import { toast } from "react-toastify";
import Loading from "./Loading";

const StorePlansRegister = ({
  open,
  storeId,
  refetch,
  onClose,
}: {
  open: boolean;
  storeId: string | number;
  refetch: () => void;
  onClose: () => void;
}) => {
  const { data: plans }: any = useQuery({
    queryFn: async () => await getStorePlans(),
    queryKey: ["getStorePlans"],
    enabled: true,
    initialData: [],
  });

  const { mutate, isPending } = useMutation({
    mutationFn: createStoreOnPlan,
    onSuccess: () => {
      onClose();
      refetch();
      toast.success("Plano cadastrado com sucesso");
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const { handleChange, values, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      id: "",
      planId: "",
    },
    onSubmit: (values) => {
      mutate({ ...values, id: storeId });
    },
  });

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container size={12} spacing={2}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={26} fontWeight={600}>
              Cadastrar plano
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          {plans?.map((item: any) => (
            <Grid2 size={12} key={item?.id}>
              <Stack
                key={item?.id}
                spacing={1}
                sx={{
                  padding: 2,
                  bgcolor:
                    Number(values.planId) === Number(item.id)
                      ? "primary.main"
                      : "secondary.light",
                  borderRadius: 2,
                  "&&:hover": {
                    cursor: "pointer",
                    bgcolor: "primary.main",
                  },
                }}
                onClick={() => setFieldValue("planId", Number(item.id))}
                onChange={handleChange}
              >
                <Stack
                  sx={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography fontWeight={700}>{item?.name}</Typography>
                  {Number(item.value) > 0 && (
                    <Typography fontWeight={700}>
                      {formatPrice(item?.value)}
                    </Typography>
                  )}
                  {Number(item.value) === 0 && (
                    <Typography fontWeight={700} color="green">
                      Grátis
                    </Typography>
                  )}
                </Stack>
                <Typography>{item?.description}</Typography>
              </Stack>
            </Grid2>
          ))}
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="medium"
              onClick={() => handleSubmit()}
            >
              <Typography variant="body2">Cadastrar plano</Typography>
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  iconStyle: {
    color: "primary.main",
  },
};
export default StorePlansRegister;
